/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { services } from '../../context';
import { UserState } from './userTypes';

const initialState: UserState = {
  isLoggedIn: false,
  businessName: '',
  firstName: '',
  lastName: '',
  email: '',
  streetAddress: '',
  streetAddress2: '',
  postCode: '',
  city: '',
  country: '',
  phoneNumber: '',
  privacyPolicy: false,
  firstNamePhonetic: '',
  lastNamePhonetic: '',
  customerType: '',
  logInStatus: 'PENDING',
};

export const getUserInformation = createAsyncThunk(
  'user/getUserInformation',
  async (_, { rejectWithValue }) => {
    const { result, error } = await services.user.getUserInformation();

    if (error || !result) {
      return rejectWithValue(error);
    }

    return result;
  },
);

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserInformation.fulfilled, (state, action) => {
        return action.payload;
      })
      .addCase(getUserInformation.rejected, () => {
        return { ...initialState, logInStatus: 'COMPLETE' };
      })
      .addCase(getUserInformation.pending, (state) => {
        return {
          ...state,
          logInStatus: 'PROCESSING',
        };
      });
  },
});

export default userSlice.reducer;
